import st_ad from './st_ad'

export default st_ad